
import { Component } from 'vue-property-decorator'
import i18n from '@/i18n'
import Vue from 'vue'
import { navigate } from '@/utils/NavigationUtils'
import TeaserAccountTile from '@/components/tile/TeaserAccountTile.vue'

@Component({
  i18n,
  components: {
    TeaserAccountTile
  }
})
export default class UserExistsPage extends Vue {
  public onSubmit(): void {
    navigate(window.ENV_CONFIG.REDIRECTS.LOGIN_PAGE)
  }
}
